import { Pipe, PipeTransform } from '@angular/core';
import { StatusMovimentacaoCadastralManual as Status } from '../../models/movimentacao-cadastral-manual/StatusMovimentacaoCadastralManual';

@Pipe({
  name: 'badgeStatusMovimentacaoCadastralManual',
})
export class BadgeStatusMovimentacaoCadastralManualPipe
  implements PipeTransform
{
  transform(value: Status): unknown {
    return {
      [Status.EmAndamento]: 'bg-primary',
      [Status.AguardandoProvedor]: 'bg-warning text-dark',
      [Status.Erro]: 'bg-danger',
      [Status.Sucesso]: 'bg-success',
    }[value];
  }
}
